export const HomeStyle = {

    mainContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: 0,
        padding: 0,
    },

    arptUrl: {
        fontSize: "14px",
        paddingBottom: "5px",
        color: "#7BA238" 
    },

}